import { SVG, SVGProps } from './svg'

export function IconCalendar(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M19 4a2 2 0 012 2v13a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h1V2.5c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5V4h8V2.5c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5V4h1zM5 19h14V8H5v11zm6.5-9c-.3 0-.5.2-.5.5v1c0 .3.2.5.5.5h5c.3 0 .5-.2.5-.5v-1c0-.3-.2-.5-.5-.5h-5zM9 11.5c0 .3-.2.5-.5.5h-1a.5.5 0 01-.5-.5v-1c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v1zm3.5 4.5c.3 0 .5-.2.5-.5v-1c0-.3-.2-.5-.5-.5h-5c-.3 0-.5.2-.5.5v1c0 .3.2.5.5.5h5zm3 0a.5.5 0 01-.5-.5v-1c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5h-1z" />
    </SVG>
  )
}
